import { stringFromOptionallyPrefixedString, stringFromPrefixedString } from "../utils";
import { Schema as S } from "effect";
export const RawSchema = S.UUID;
export const Schema = stringFromPrefixedString("$SuperwallAlias:", RawSchema).pipe(S.brand("@open-revenue/schema/AliasId"));
export const FromOptionallyPrefixedString = stringFromOptionallyPrefixedString("$SuperwallAlias:", RawSchema).pipe(S.brand("@open-revenue/schema/AliasId"));
export const ArrayFromOptionallyPrefixedStrings = S.compose(S.split(","), S.Array(FromOptionallyPrefixedString));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const random = ()=>S.decode(Schema)(`$SuperwallAlias:${crypto.randomUUID()}`);
export const encode = (id)=>S.encode(Schema)(id);
export const FromUnPrefixedString = RawSchema.pipe(S.brand("@open-revenue/schema/AliasId"));
